import * as React from 'react';
import { ClassableProps, baseClassAnd } from "@jcharlesworthuk/your-mum-core/dist/functions";

type Props = ClassableProps & {
}

const DrawnCircleSvg: React.FunctionComponent<Props> = props => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 22" className={baseClassAnd('drawn-circle-svg', props)}><path d="M10.709 1.952c3.2-.01 6.641.588 9.21 3.466 1.602 1.874 3.151 4.31 3.12 7.35-.084 2.036-.751 4.058-2.039 5.223-1.288 1.165-2.134 2.025-4.632 2.332-2.498.307-7.513-1.37-10.876-3.844-1.286-1.071-3.175-2.996-3.926-4.876-.735-1.767-.917-3.32.452-5.694 1.37-2.375 3.68-3.7 5.534-4.344 1.854-.644 4.056-.562 4.056-.562-.519.73-1.254.777-1.914 1.069-1.951.601-2.453.545-3.853 1.546-1.4 1.001-2.82 2.474-3.344 4.804-.4 1.877.516 3.498 1.567 4.562 2.134 2.261 3.729 3.484 6.26 4.692 2.422 1.057 4.656 1.78 7.174.993 1.044-.227 2.316-1.009 3.02-2.114 1.231-1.74 1.306-3.884.523-6.053-1.226-3.74-4.06-5.731-6.929-6.586-1.671-.533-3.817-1.028-4.043-1.413-.226-.385.435-.345.64-.55z" fill="#00d6d6"/></svg>
}

export default DrawnCircleSvg;

